module.exports = __webpack_public_path__ + "static/media/ngr.0d0edb99.svg";